class PromoAnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.enableDismiss = this.dataset.enableDismiss === 'true';
    this.storageKey = `announcement_dismissed_${this.sectionId}`;

    this.codeButton = this.querySelector('.promo-announcement-bar__code');
    this.closeButton = this.querySelector('.promo-announcement-bar__close');

    if (this.codeButton) {
      this.codeButton.addEventListener('click', this.onCodeClick);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onDismiss);
    }
  }

  disconnectedCallback() {
    if (this.codeButton) {
      this.codeButton.removeEventListener('click', this.onCodeClick);
    }

    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.onDismiss);
    }
  }

  onDismiss = () => {
    this.style.maxHeight = `${this.offsetHeight}px`;
    this.style.opacity = '0';
    this.style.overflow = 'hidden';
    this.style.transition = 'max-height 0.3s ease, padding 0.3s ease, opacity 0.2s ease';

    window.setTimeout(() => {
      this.style.maxHeight = '0';
      this.style.padding = '0';
    }, 50);

    window.setTimeout(() => {
      this.classList.add('promo-announcement-bar--hidden');
    }, 350);
  };

  onCodeClick = async (event) => {
    const button = event.currentTarget;
    const code = button.dataset.code;

    if (!code) {
      return;
    }

    const copied = await this.copyTextFallback(code);
    if (!copied) {
      return;
    }

    const originalText = button.dataset.originalText || button.textContent;
    button.dataset.originalText = originalText;
    button.textContent = 'Copied!';

    window.setTimeout(() => {
      button.textContent = originalText;
    }, 1500);
  };

  async copyTextFallback(text) {
    if (!navigator.clipboard?.writeText) {
      return false;
    }
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (_) {
      return false;
    }
  }
}

if (!window.customElements.get('promo-announcement-bar')) {
  window.customElements.define('promo-announcement-bar', PromoAnnouncementBar);
}
